module.exports = __webpack_public_path__ + "produkte_active.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/produkte_active.svg
// module id = 118
// module chunks = 0